const StoreTypeGridPluginSettings: IPluginSettings = {
    name: 'Типы складов',
    mnemocode: 'store_type_plugin',
    permission: 'StoreType',
    columns: [{
        order: 2,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 257
    }, {
        order: 3,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 157
    }, {
        order: 1,
        propertyName: 'requireInputGoscontractOnInvoice',
        propertyType: 'boolean',
        displayName: 'Ввод Госконтракта',
        visibility: true,
        width: 157
    }, {
        order: 0,
        propertyName: 'mnemocode',
        propertyType: 'string',
        displayName: 'Мнемокод',
        visibility: true,
        width: 257
    }, {
        order: 4,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 157
    }
    ]
}

export default StoreTypeGridPluginSettings